import { OrdersAggregatedData } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrdersAggregatedData>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrdersStatsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrdersStats.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminOrdersStats.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminOrdersStats.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminOrdersStats.reset.type]: actionsHandlers.handleGetOneReset,
});

export default adminOrdersStatsReducer;
